"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarStyles = void 0;
const lit_1 = require("lit");
const utils_1 = require("@/utils");
const avatarSizeTokens = {
    '80': { '--avatar-size': 'var(--size-80)', 'font-size': 'var(--font-size-32)' },
    '48': { '--avatar-size': 'var(--size-48)', 'font-size': 'var(--font-size-24)' },
    '32': { '--avatar-size': 'var(--size-32)', 'font-size': 'var(--font-size-12)' },
};
const avatarVariantTokens = {
    primary: { border: 'var(--avatar-border)' },
    secondary: {
        '--avatar-background-color': 'var(--background-color)',
        '--avatar-border': 'var(--border)',
    },
    tertiary: {
        '--avatar-background-color': 'transparent',
        '--avatar-border': 'none',
        'box-shadow': 'none',
    },
};
exports.avatarStyles = (0, lit_1.css) `
  :host {
    --avatar-size: var(--size-40);
    --avatar-background-color: var(--background-subtle-color);
    --avatar-icon-color: var(--foreground-color);
    --avatar-border: var(--border-transparent);
    --avatar-border-radius: var(--radius);

    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: var(--avatar-size);
    height: var(--avatar-size);
    max-height: var(--avatar-size);
    background-repeat: no-repeat;
    background-position: center;
    background-color: var(--avatar-background-color);
    border: var(--avatar-border);
    border-radius: var(--avatar-border-radius);
    box-sizing: border-box;
    position: relative;
    color: var(--avatar-icon-color);
  }

  :host([shape='circle']) {
    --avatar-border-radius: var(--radius-full);
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', avatarSizeTokens))}

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('variant', avatarVariantTokens))}

  img {
    width: 100%;
    height: 100%;
    border-radius: var(--avatar-border-radius);
    object-fit: cover;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXZhdGFyLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImF2YXRhci5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQW9DO0FBSXBDLG1DQUFtRTtBQUVuRSxNQUFNLGdCQUFnQixHQUErQztJQUNuRSxJQUFJLEVBQUUsRUFBRSxlQUFlLEVBQUUsZ0JBQWdCLEVBQUUsV0FBVyxFQUFFLHFCQUFxQixFQUFFO0lBQy9FLElBQUksRUFBRSxFQUFFLGVBQWUsRUFBRSxnQkFBZ0IsRUFBRSxXQUFXLEVBQUUscUJBQXFCLEVBQUU7SUFDL0UsSUFBSSxFQUFFLEVBQUUsZUFBZSxFQUFFLGdCQUFnQixFQUFFLFdBQVcsRUFBRSxxQkFBcUIsRUFBRTtDQUNoRixDQUFBO0FBRUQsTUFBTSxtQkFBbUIsR0FBbUM7SUFDMUQsT0FBTyxFQUFFLEVBQUUsTUFBTSxFQUFFLHNCQUFzQixFQUFFO0lBQzNDLFNBQVMsRUFBRTtRQUNULDJCQUEyQixFQUFFLHlCQUF5QjtRQUN0RCxpQkFBaUIsRUFBRSxlQUFlO0tBQ25DO0lBQ0QsUUFBUSxFQUFFO1FBQ1IsMkJBQTJCLEVBQUUsYUFBYTtRQUMxQyxpQkFBaUIsRUFBRSxNQUFNO1FBQ3pCLFlBQVksRUFBRSxNQUFNO0tBQ3JCO0NBQ0YsQ0FBQTtBQUVZLFFBQUEsWUFBWSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQTZCM0IsSUFBQSxlQUFTLEVBQUMsSUFBQSwyQkFBbUIsRUFBQyxNQUFNLEVBQUUsZ0JBQWdCLENBQUMsQ0FBQzs7SUFFeEQsSUFBQSxlQUFTLEVBQUMsSUFBQSwyQkFBbUIsRUFBQyxTQUFTLEVBQUUsbUJBQW1CLENBQUMsQ0FBQzs7Ozs7Ozs7Q0FRakUsQ0FBQSJ9